import React from 'react';
import { SidePanel } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_SIZE_TABLET_SMALL,
  SCREEN_WIDTH_QUERIES,
} from '../../misc/constants';
import { ModuleDetails } from '../../models/PamModels';

import SidePanelFooter from './SidePanelFooter/SidePanelFooter';
import SidePanelView from './SidePanelView/SidePanelView';
import { ASSET_TYPES, TYPES } from './constants';

import './LandingPageSidePanel.css';

function LandingPageSidePanel({
  data,
  isOpen,
  onClose,
  credentialRequestOnClick,
  checkoutRoleOnClick,
  dataTestId,
  setIsCheckInModalOpen,
  setIconClickedForRow,
  setCheckInModalKind,
  setIsExtendModalOpen,
  setSessionToLaunch,
  setIsSessionTargetModalVisible,
  setSessionDetailsForAd,
  mediaQueryValue,
  handlePreviousRow,
  handleNextRow,
  isPreviousDisabled,
  isNextDisabled,
  isBulkRolesSelectMode,
  isJitForApps,
  className,
}) {
  const classes = classnames('LandingPageSidePanel', className);

  const tabletSmallQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_TABLET_SMALL
  );
  const mobileXlargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );
  const isTabletWidth = tabletSmallQuery.value <= mediaQueryValue;
  const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;

  const setIcon = () => {
    if (data.type === TYPES.ROLE) {
      return 'Role';
    }

    switch (data.assetType) {
      case ASSET_TYPES.ACCOUNT:
        return 'Account';
      case ASSET_TYPES.APPLICATION:
        return 'Application';
      case ASSET_TYPES.DATABASE:
        return 'Database';
      case ASSET_TYPES.SERVER:
        return 'Server';
      case ASSET_TYPES.CONSOLE:
        return 'WebAppConsole';
      default:
        return 'Application';
    }
  };

  const getHeaderTitle = () => {
    const {
      roleName,
      roleDisplayName,
      endpointDisplayName,
      endointName,
      endpointName,
      accountName,
    } = data;

    if (roleName) {
      if (roleDisplayName) {
        return roleDisplayName;
      }

      return roleName;
    }

    return endpointDisplayName || endointName || endpointName || accountName;
  };

  return (
    <SidePanel
      header={{
        title: getHeaderTitle(),
        description: data.roleType || data.assetType || 'No Description',
        icon: setIcon(),
      }}
      isOpen={isOpen}
      onClose={onClose}
      className={classes}
      layout={
        <SidePanelView
          data={data}
          isMobileWidth={isMobileXlargeWidth}
          isJitForApps={isJitForApps}
        />
      }
      classNames={{
        innerContentClassName:
          'LandingPage-sidePanelInnerContent LandingPageSidePanel-innerContent',
        headerClassName:
          data.type === 'endpoint'
            ? 'LandingPageSidePanel-noTabGroupHeader'
            : null,
        layoutClassName:
          data.type === 'endpoint' ? 'LandingPageSidePanel-layout' : null,
        footerClassName: 'LandingPageSidePanel-footer',
      }}
      footer={
        <SidePanelFooter
          data={data}
          credentialRequestOnClick={credentialRequestOnClick}
          checkoutRoleOnClick={checkoutRoleOnClick}
          setIsCheckInModalOpen={setIsCheckInModalOpen}
          setIconClickedForRow={setIconClickedForRow}
          setSidePanelOnClose={onClose}
          setCheckInModalKind={setCheckInModalKind}
          setIsExtendModalOpen={setIsExtendModalOpen}
          setSessionToLaunch={setSessionToLaunch}
          setIsSessionTargetModalVisible={setIsSessionTargetModalVisible}
          setSessionDetailsForAd={setSessionDetailsForAd}
          isBulkRolesSelectMode={isBulkRolesSelectMode}
          isJitForApps={isJitForApps}
        />
      }
      showCenterMessage
      isTabletWidth={isTabletWidth}
      isMobileWidth={isMobileXlargeWidth}
      // List Navigation
      isSidePanelNavigatingList
      handlePrevious={handlePreviousRow}
      handleNext={handleNextRow}
      isPreviousDisabled={isPreviousDisabled}
      isNextDisabled={isNextDisabled}
      dataTestId={dataTestId}
    />
  );
}

LandingPageSidePanel.propTypes = {
  data: ModuleDetails,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  credentialRequestOnClick: PropTypes.func.isRequired,
  checkoutRoleOnClick: PropTypes.func.isRequired,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  setIsCheckInModalOpen: PropTypes.func,
  setIconClickedForRow: PropTypes.func,
  setCheckInModalKind: PropTypes.func,
  setIsExtendModalOpen: PropTypes.func,
  setSessionToLaunch: PropTypes.func,
  setIsSessionTargetModalVisible: PropTypes.func,
  setSessionDetailsForAd: PropTypes.func,
  mediaQueryValue: PropTypes.number.isRequired,
  handlePreviousRow: PropTypes.func.isRequired,
  handleNextRow: PropTypes.func.isRequired,
  isPreviousDisabled: PropTypes.bool.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
  isBulkRolesSelectMode: PropTypes.bool.isRequired,
  isJitForApps: PropTypes.bool,
};

LandingPageSidePanel.defaultProps = {
  data: null,
  isOpen: false,
  onClose: () => {},
  dataTestId: null,
  className: null,
  setIsCheckInModalOpen: null,
  setIconClickedForRow: null,
  setCheckInModalKind: null,
  setIsExtendModalOpen: null,
  setSessionToLaunch: null,
  setIsSessionTargetModalVisible: null,
  setSessionDetailsForAd: null,
  isJitForApps: false,
};
export default LandingPageSidePanel;
